import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    padding: '15px',
    margin: '10px 0px',
    background: theme.palette.grey[200],
    borderRadius: 8
  },
  secondaryTitle: {
    color: theme.palette.text.primary,
    fontSize: 18,
    margin: '10px 0px'
  },
  hotelNamedetails: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    marginTop: 6
  },
  greyText: {
    color: theme.palette.grey[600],
    [theme.breakpoints.down('sm')]: {
      fontSize: 12
    }
  },
  seprator: {
    width: '1px',
    height: '20px',
    margin: '0 10px',
    display: 'flex',
    alignItems: 'flex- start',
    background: theme.palette.grey[500]
  },

  icon: { marginRight: 4, fontSize: 18, padding: 0 }
}))
export default useStyles
